import NoLogo from "src/assets/png/image_logo-default.png";
import NoFavicon from "src/assets/png/image_favicon-default.png";

export const baseUrl = process.env.REACT_APP_API_BASE_URL || window.API_BASE_URL;

export const apiUrl = baseUrl + "/api";
export const filePath = baseUrl + "/uploads";
export const noLogo = NoLogo;
export const noFavicon = NoFavicon;
